import Vue from 'vue';
import store from '../store/store';

export default new class UtilityService extends Vue {
  extendComponent(name, Component, animation = 'lift') {
    return {
      name,
      extends: Component,
      onsNavigatorOptions: {animation: animation}
    };
  }

  /**
   * 検索タイプと検索結果をアップデートします
   * @param {string} type   検索タイプ 0: キーワード検索, 1: エリア検索, 2: 絞り込み検索 
   * @param {array}  result 検索結果 
   */
  setSearchResult(type, result) {
    store.dispatch('updateSearchType', type);
    store.dispatch('updateResult', result);
  }
}